export default {
    project: 'Project',
    save: 'Save',
    confirm: 'Confirm',
    cancel: 'Cancel',
    update: 'Update',
    edite: 'Edit',
    delete: 'Delete',
    tips: 'Tips',
    success: 'Success',
    addsucc: 'Add success',
    updatesucc: 'Update success',
    deletesucc: 'Delete success',
    main: {
        language: {
            buttonTitle: 'Languages',
            switchSuccessTip: 'Switch Language Success !'
        },
        webparts: {
            project: {
                finish: 'finished',
                project: 'Project',
                errorRate: 'error rate',
                task: 'Task',
                normal: 'normal',
                late: 'late',
                leaveEarly: 'leave early',
                appeal: 'appeal'
            }
        },
        logout: 'Logout',
        setting: 'Setting',
        theme: 'Theme',
        sidebar: 'Sidebar',
        sidebarSwitch: 'Collapse',
        right: 'All Rights Reserved.',
        mail: 'mail',
        message: 'message',
    },
    setting: {
        menuname: 'Shortcut | Application',
        shortcut: 'Shortcut',
        application: 'Application',
        status: 'Status',
        operate: 'Operate',
        update: 'update',
        delete: 'delete',
        disable: 'Disable',
        able: 'Enable',
        newshortcut: 'New shortcut',
        newapplication: 'New application',
        editeshortcut: 'Edite shortcut',
        editeapplication: 'Edite application',
        opentype1: 'Self',
        opentype2: 'Blank',
        target: 'Target',
        link: 'Link',
        avater: 'Avater',
        shortcutname: 'Name',
        nameplace: 'Click on the icon behind to set up English',
        linkplace: 'Please input the link',
        codeplace: 'Please enter code，English only',
        translateplace: 'Please input',
        translatetitle: 'Add translate fields',
        flag: 'Code',
        content: 'Content',
        appliactionname: 'Name',
        phototype: 'Upload pictures can only be in JPG, PNG, GIF, SVG format!',
        photosize: 'Upload picture size can not exceed 2MB!',
        validshotname: 'Please input name',
        validappname: 'Please input name',
        validnamelen: 'No more than 20 characters',
        validupload: 'Please upload icons',
        validlink: 'Please input url',
        validtrans: 'Please input content',
        validflag: 'Please input the code',
        validenglish: 'Please input the correct code，English only',
        tipsdesc: 'Continue delete?',
        chinese: 'Chinese',
        english: 'English',
        done:'Done',
        draft:'Draft',
        waiting:'Waiting',
    }
}
